import { FaxTypeOption } from 'src/app/pages/fax-register/models/fax-type-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const faxTypeOptionActions = createEagerSelectActions<FaxTypeOption>('[Fax Type Options]');
